import type {Dayjs} from 'dayjs'

export const formatIsoDate = (date: Dayjs): string => {
  return date.startOf('day').format('YYYY-MM-DD')
}
